import React, { useCallback, useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Modal, Toast, ToastContainer, Spinner } from "react-bootstrap";
import axios from "../../axios/axiosconf";
import { ArchivosClinicosContenido, ArchivosControlSubir, verificarCuotaArchivosClinicos, ArchivosCuotaIndicador } from "./ModalArchivosClinicos";
import ModalAyudasDiagnosticasProximamente from "./ModalAyudasDiagnosticasProximamente";
import RegistroRipsSinFev from "../rips/RegistroRipsSinFev";
import RegistroRipsFev from "../rips/RegistroRipsFev";
import RegistroRipsConvenio from "../rips/RegistroRipsConvenio";
import ModalExamenes from "./ModalExamenes";
import ModalFormulas from "./ModalFormulas";
import ModalIncapacidades from "./ModalIncapacidades";
import ModalRecomendaciones from "./ModalRecomendaciones";
import ModalRemisiones from "./ModalRemisiones";
import ModalContraremisiones from "./ModalContraremisiones";
import ModalConsentimientos from "./ModalConsentimientos";
import ModalOdontograma from "./ModalOdontograma";
import DocumentoPacienteModal from "./DocumentoPacienteModal";
import ModalToxina from "./ModalToxina";

function AyudasDiagnosticasPaciente() {
    const queryParams = useLocation().search;
    const pacienteId = new URLSearchParams(queryParams).get("id");
    const history = useHistory();

    const [paciente, setPaciente] = useState(null);
    const [cuota, setCuota] = useState({ limite_bytes: 0, consumo_bytes: 0 });
    const [verificandoCuota, setVerificandoCuota] = useState(true);
    const [cuotaLista, setCuotaLista] = useState(false);
    const [toastMsg, setToastMsg] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [esFacturador, setEsFacturador] = useState(false);

    const [showRipsFev, setShowRipsFev] = useState(false);
    const [showRipsSinFev, setShowRipsSinFev] = useState(false);
    const [showRipsConvenio, setShowRipsConvenio] = useState(false);
    const [showExamenes, setShowExamenes] = useState(false);
    const [showFormulas, setShowFormulas] = useState(false);
    const [showIncapacidades, setShowIncapacidades] = useState(false);
    const [showRecomendaciones, setShowRecomendaciones] = useState(false);
    const [showRemisiones, setShowRemisiones] = useState(false);
    const [showContraremisiones, setShowContraremisiones] = useState(false);
    const [showConsentimientos, setShowConsentimientos] = useState(false);
    const [showOdontograma, setShowOdontograma] = useState(false);
    const [showToxina, setShowToxina] = useState(false);

    const [cargarHistorialExamenes, setCargarHistorialExamenes] = useState(false);
    const [cargarHistorialFormulas, setCargarHistorialFormulas] = useState(false);
    const [cargarHistorialIncapacidades, setCargarHistorialIncapacidades] = useState(false);
    const [cargarHistorialRecomendaciones, setCargarHistorialRecomendaciones] = useState(false);
    const [cargarHistorialRemisiones, setCargarHistorialRemisiones] = useState(false);
    const [cargarHistorialContraremisiones, setCargarHistorialContraremisiones] = useState(false);
    const [cargarHistorialConsentimientos, setCargarHistorialConsentimientos] = useState(false);
    const [cargarHistorialRipsConvenio, setCargarHistorialRipsConvenio] = useState(false);

    const [tienePermisoDocumentos, setTienePermisoDocumentos] = useState(false);
    const [tienePermisoRips, setTienePermisoRips] = useState(false);
    const [tienePermisoToxina, setTienePermisoToxina] = useState(false);
    const [tienePermisoOdontograma, setTienePermisoOdontograma] = useState(false);
    const [tienePermisoEvolucion, setTienePermisoEvolucion] = useState(false);
    const [tienePermisoHistoriaClinica, setTienePermisoHistoriaClinica] = useState(false);
    const [subirArchivosControl, setSubirArchivosControl] = useState(null);

    const handleExposeSubir = useCallback((props) => {
        setSubirArchivosControl(props);
    }, []);

    useEffect(() => {
        try {
            const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");
            setEsFacturador(parseInt(userdata?.facturador, 10) === 0);
        } catch {
            setEsFacturador(false);
        }
    }, []);

    useEffect(() => {
        if (!pacienteId) return;
        const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");
        axios.get("/paciente", {
            headers: { Authorization: "Bearer " + userdata.access_token },
            params: { id: pacienteId },
        }).then((response) => {
            const datos = Array.isArray(response.data) ? response.data[0] : response.data;
            if (!datos) return;
            setPaciente({
                id: datos.id,
                primerNombre: datos.primer_nombre,
                segundoNombre: datos.segundo_nombre,
                primerApellido: datos.primer_apellido,
                segundoApellido: datos.segundo_apellido,
                tipoDocumento: datos.tipo_documento,
                numeroDocumento: datos.numero_documento,
            });
        }).catch(() => {});
    }, [pacienteId]);

    useEffect(() => {
        if (!pacienteId) return undefined;
        let activo = true;
        setVerificandoCuota(true);
        setCuotaLista(false);

        verificarCuotaArchivosClinicos(pacienteId)
            .then((nuevaCuota) => {
                if (!activo) return;
                setCuota(nuevaCuota);
                setCuotaLista(true);
            })
            .finally(() => {
                if (activo) setVerificandoCuota(false);
            });

        return () => {
            activo = false;
        };
    }, [pacienteId]);

    useEffect(() => {
        try {
            const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");
            const verificarPermiso = (slug) => {
                if (userdata.permissions && Array.isArray(userdata.permissions)) {
                    return userdata.permissions.some((p) => p.slug === slug);
                }
                if (userdata.up && Array.isArray(userdata.up)) {
                    return userdata.up.includes(slug);
                }
                return false;
            };
            setTienePermisoDocumentos(verificarPermiso("documentosPaciente"));
            setTienePermisoRips(verificarPermiso("ripsPaciente"));
            setTienePermisoToxina(verificarPermiso("toxinaPaciente"));
            setTienePermisoOdontograma(verificarPermiso("odontogramaPaciente"));
            setTienePermisoEvolucion(verificarPermiso("evolucionPaciente"));
            setTienePermisoHistoriaClinica(verificarPermiso("historiaClinicaPaciente"));
        } catch {
            setTienePermisoDocumentos(false);
            setTienePermisoRips(false);
            setTienePermisoToxina(false);
            setTienePermisoOdontograma(false);
        }
    }, []);

    const obtenerPacienteParaRips = () => ({
        id: paciente?.id || pacienteId,
        primerNombre: paciente?.primerNombre || "",
        segundoNombre: paciente?.segundoNombre || "",
        primerApellido: paciente?.primerApellido || "",
        segundoApellido: paciente?.segundoApellido || "",
        numeroDocumento: paciente?.numeroDocumento || "",
        tipoDocumento: paciente?.tipoDocumento || "CC",
    });

    const volverAtenderPaciente = () => history.push(`/atender-paciente?id=${pacienteId}`);
    const abrirEvolucion = () => history.push(`/evolucion-paciente?id=${pacienteId}`);
    const abrirHistoriaClinicaJson = () => history.push(`/historia-clinica-json?id=${pacienteId}`);
    const getInfoAnamnesisPDF = () => "";

    const guardarCambios = (msg) => {
        setToastMsg(msg);
        setShowToast(true);
    };

    const abrirExamenes = () => { setShowExamenes(true); setCargarHistorialExamenes(true); };
    const cerrarExamenes = () => { setShowExamenes(false); setCargarHistorialExamenes(false); };
    const abrirFormulas = () => { setShowFormulas(true); setCargarHistorialFormulas(true); };
    const cerrarFormulas = () => { setShowFormulas(false); setCargarHistorialFormulas(false); };
    const abrirIncapacidades = () => { setShowIncapacidades(true); setCargarHistorialIncapacidades(true); };
    const cerrarIncapacidades = () => { setShowIncapacidades(false); setCargarHistorialIncapacidades(false); };
    const abrirRecomendaciones = () => { setShowRecomendaciones(true); setCargarHistorialRecomendaciones(true); };
    const cerrarRecomendaciones = () => { setShowRecomendaciones(false); setCargarHistorialRecomendaciones(false); };
    const abrirRemisiones = () => { setShowRemisiones(true); setCargarHistorialRemisiones(true); };
    const cerrarRemisiones = () => { setShowRemisiones(false); setCargarHistorialRemisiones(false); };
    const abrirContraremisiones = () => { setShowContraremisiones(true); setCargarHistorialContraremisiones(true); };
    const cerrarContraremisiones = () => { setShowContraremisiones(false); setCargarHistorialContraremisiones(false); };
    const abrirConsentimientos = () => { setShowConsentimientos(true); setCargarHistorialConsentimientos(true); };
    const cerrarConsentimientos = () => { setShowConsentimientos(false); setCargarHistorialConsentimientos(false); };
    const abrirOdontograma = () => setShowOdontograma(true);
    const cerrarOdontograma = () => setShowOdontograma(false);
    const abrirToxina = () => setShowToxina(true);
    const cerrarToxina = () => setShowToxina(false);
    const abrirRipsConvenio = () => { setShowRipsConvenio(true); setCargarHistorialRipsConvenio(true); };
    const cerrarRipsConvenio = () => { setShowRipsConvenio(false); setCargarHistorialRipsConvenio(false); };

    if (!pacienteId) {
        return (
            <div className="content-wrapper p-4">
                <div className="alert alert-warning">No se indicó el paciente. Use <code>?id=</code> en la URL.</div>
            </div>
        );
    }

    const moduloHabilitado = cuotaLista && Number(cuota.limite_bytes) > 0;
    const mostrarPromo = cuotaLista && !moduloHabilitado;

    return (
        <>
            <Header />
            <Aside
                activelink="patients"
                atencionPaciente={true}
                abrirEvolucion={abrirEvolucion}
                abrirHistoriaClinicaJson={abrirHistoriaClinicaJson}
                abrirExamenes={abrirExamenes}
                abrirArchivosClinicos={() => {}}
                abrirFormulas={abrirFormulas}
                abrirIncapacidades={abrirIncapacidades}
                abrirRecomendaciones={abrirRecomendaciones}
                abrirRemisiones={abrirRemisiones}
                abrirContraremisiones={abrirContraremisiones}
                abrirConsentimientos={abrirConsentimientos}
                abrirRipsFev={() => setShowRipsFev(true)}
                abrirRipsSinFev={() => setShowRipsSinFev(true)}
                abrirRipsConvenio={abrirRipsConvenio}
                abrirOdontograma={abrirOdontograma}
                abrirToxina={abrirToxina}
                esFacturador={esFacturador}
                tienePermisoDocumentos={tienePermisoDocumentos}
                tienePermisoRips={tienePermisoRips}
                tienePermisoOdontograma={tienePermisoOdontograma}
                tienePermisoToxina={tienePermisoToxina}
                tienePermisoEvolucion={tienePermisoEvolucion}
                tienePermisoHistoriaClinica={tienePermisoHistoriaClinica}
            />

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb mb-1">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item"><Link to={`/atender-paciente?id=${pacienteId}`}>Atender Paciente</Link></li>
                                    <li className="breadcrumb-item active">Ayudas Diagnósticas</li>
                                </ol>
                                <h1 className="m-0">
                                    <i className="fas fa-images mr-2" />Ayudas Diagnósticas
                                </h1>
                                {moduloHabilitado && (
                                    <ArchivosCuotaIndicador
                                        cuota={cuota}
                                        className="archivos-cuota-indicador--pagina mt-2"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row mb-3">
                            <div className="col-12 d-flex flex-wrap align-items-center archivos-pagina-acciones">
                                <button type="button" className="btn btn-secondary mr-2 mb-2" onClick={volverAtenderPaciente}>
                                    <i className="fas fa-arrow-left mr-2" />
                                    Volver a Atender Paciente
                                </button>
                                {subirArchivosControl && (
                                    <ArchivosControlSubir
                                        className="mb-2"
                                        {...subirArchivosControl}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="card card-outline card-secondary">
                            <div className="card-body">
                                {verificandoCuota || !cuotaLista ? (
                                    <div className="text-center py-5">
                                        <Spinner animation="border" />
                                    </div>
                                ) : moduloHabilitado ? (
                                    <ArchivosClinicosContenido
                                        pacienteId={pacienteId}
                                        activo
                                        guardarCambios={guardarCambios}
                                        modoPagina
                                        onCuotaChange={setCuota}
                                        onExposeSubir={handleExposeSubir}
                                    />
                                ) : (
                                    <div className="text-center text-muted py-4">
                                        <i className="fas fa-images fa-2x mb-2 d-block" style={{ color: "#323A45" }} />
                                        <p className="mb-0">Módulo de imágenes y documentos no activo para esta clínica.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <ToastContainer position="top-end" className="p-3">
                <Toast bg="success" show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide>
                    <Toast.Body className="text-white">{toastMsg}</Toast.Body>
                </Toast>
            </ToastContainer>

            <ModalAyudasDiagnosticasProximamente
                show={mostrarPromo}
                onHide={volverAtenderPaciente}
            />

            <Modal show={showRipsSinFev} onHide={() => setShowRipsSinFev(false)} size="xl" enforceFocus={false}>
                <Modal.Header closeButton><Modal.Title>Registro RIPS Sin FEV</Modal.Title></Modal.Header>
                <Modal.Body><RegistroRipsSinFev paciente={obtenerPacienteParaRips()} /></Modal.Body>
            </Modal>
            <Modal show={showRipsFev} onHide={() => setShowRipsFev(false)} size="xl" enforceFocus={false}>
                <Modal.Header closeButton><Modal.Title>Registro RIPS FEV</Modal.Title></Modal.Header>
                <Modal.Body><RegistroRipsFev paciente={obtenerPacienteParaRips()} onClose={() => setShowRipsFev(false)} /></Modal.Body>
            </Modal>
            <Modal show={showRipsConvenio} onHide={cerrarRipsConvenio} size="xl" enforceFocus={false}>
                <Modal.Header closeButton><Modal.Title>Registro RIPS Por Convenio</Modal.Title></Modal.Header>
                <Modal.Body><RegistroRipsConvenio cargarHistorial={cargarHistorialRipsConvenio} cerrarModal={cerrarRipsConvenio} paciente={obtenerPacienteParaRips()} /></Modal.Body>
            </Modal>
            <DocumentoPacienteModal show={showExamenes} onHide={cerrarExamenes} title="Ayudas Diagnósticas (historial)">
                <ModalExamenes cargarHistorial={cargarHistorialExamenes} cerrarModal={cerrarExamenes} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <DocumentoPacienteModal show={showFormulas} onHide={cerrarFormulas} title="Fórmulas Médicas">
                <ModalFormulas cargarHistorial={cargarHistorialFormulas} cerrarModal={cerrarFormulas} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <DocumentoPacienteModal show={showIncapacidades} onHide={cerrarIncapacidades} title="Incapacidades">
                <ModalIncapacidades cargarHistorial={cargarHistorialIncapacidades} cerrarModal={cerrarIncapacidades} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <DocumentoPacienteModal show={showRecomendaciones} onHide={cerrarRecomendaciones} title="Recomendaciones">
                <ModalRecomendaciones cargarHistorial={cargarHistorialRecomendaciones} cerrarModal={cerrarRecomendaciones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <DocumentoPacienteModal show={showRemisiones} onHide={cerrarRemisiones} title="Remisiones">
                <ModalRemisiones cargarHistorial={cargarHistorialRemisiones} cerrarModal={cerrarRemisiones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <DocumentoPacienteModal show={showContraremisiones} onHide={cerrarContraremisiones} title="Contraremisiones">
                <ModalContraremisiones cargarHistorial={cargarHistorialContraremisiones} cerrarModal={cerrarContraremisiones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <DocumentoPacienteModal show={showConsentimientos} onHide={cerrarConsentimientos} title="Consentimientos">
                <ModalConsentimientos cargarHistorial={cargarHistorialConsentimientos} cerrarModal={cerrarConsentimientos} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento} paciente={paciente} />
            </DocumentoPacienteModal>
            <Modal show={showOdontograma} onHide={cerrarOdontograma} size="xl">
                <Modal.Header closeButton><Modal.Title>Odontograma</Modal.Title></Modal.Header>
                <Modal.Body><ModalOdontograma paciente={paciente} cerrarModal={cerrarOdontograma} /></Modal.Body>
            </Modal>
            <Modal show={showToxina} onHide={cerrarToxina} size="xl">
                <Modal.Header closeButton><Modal.Title>Registro Toxina Botulínica</Modal.Title></Modal.Header>
                <Modal.Body><ModalToxina paciente={paciente} cerrarModal={cerrarToxina} /></Modal.Body>
            </Modal>

            <Footer showToast={false} delay={0} />
        </>
    );
}

export default AyudasDiagnosticasPaciente;
